import service from './../utils/server'

const modName = '/common/web/download/';

//文件下载
export const apiDownloadFile = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'file/'+data,
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/api/file.js